import type { IGenericError } from '@allesauto/core/genericError';
import translate from '@allesauto/i18n';
import dynamic from 'next/dynamic';
import React, { Component, ErrorInfo, ReactNode } from 'react';

import { intlHOC } from '@/global/hoc/intlHoc';

// workaround import path due to webpack bug https://github.com/webpack/webpack/issues/13865
const GenericError = dynamic<IGenericError>(
  () => import('../../../../../packages/allesauto-core/src/lib/genericError')
);

interface Props {
  children: ReactNode;
  intl?: any;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
  };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // eslint-disable-next-line no-console
    console.error('Error msg', { error, errorInfo });
  }

  render() {
    const { intl, children } = this.props;
    const { state } = this;

    if (state.hasError) {
      return (
        <GenericError
          heading={translate(intl, 'ui.GENERIC_ERROR.HEADING')}
          description={translate(intl, 'ui.GENERIC_ERROR.DESCRIPTION')}
          ctaText={translate(intl, 'ui.GENERIC_ERROR.CTA_TEXT')}
          onClick={() => this.setState({ hasError: false })}
        />
      );
    }

    return children;
  }
}

export default intlHOC(ErrorBoundary);
